<template>
  <form id="search-form" v-on:submit.prevent class="meilisearch-search-wrapper h-full search-box relative" role="search">
    <input
      ref="searchinput"
      id="iungo-search-input"
      class="search-query border border-gray-300 rounded-md px-2 py-1 focus:border-gray-500 focus:outline-none text-sm focus:shadow-sm appearance-none"
      :placeholder="placeholder" v-model="searchInput"
      @blur="hideMenu()"
      @focus="showMenu()"
    />
    <transition name="fade">
      <div v-if="loading" class="absolute top-0 right-0 mt-1 mr-1.5 text-gray-400" ><i class="fal fa-circle-notch fa-spin"></i></div>

    </transition>

  </form>
</template>
<script>
import DocsSearchBar from "./src/lib/DocsSearchBar";
export default {
  name: "SearchBar",
  props: {
    eventId: {
      type: String,
      default: null
    },
  domain: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      placeholder: "Search",
      docsSearchBar:null,
      searchInput: null,
    };
  },
  watch: {

    options(newValue) {
      this.update(newValue);
    },
  },
  mounted() {
    const options = {
      hostUrl: "https://"+this.domain+"/customer/searchEvent/"+this.eventId,
      autocompleteOptions: {
        debug: true,
      },
    };
    this.initialize(options);
    this.placeholder =
      this.translate('conference.search') || this.$site.themeConfig.searchPlaceholder || "";
  },

  methods: {
    initialize(userOptions) {

      Promise.all([]).then(([docsSearchBar]) => {
        const input = Object.assign({}, userOptions, {
          inputSelector: this.$refs.searchinput,
          queryHook: (query) => {
            this.loading = true;

            return query;
          },
          transformData: (hits) => {
            this.loading = false;

            return hits;
          },
          handleSelected: (input, event, suggestion) => {
            //console.log("SELECTED SUGGESTION", suggestion);
            if (suggestion.entity) {
                 if (suggestion.entity.type == "App\\Models\\Person") {
                 //  window.conferenceBus.$emit("showProfile",{id:suggestion.entity.id,type:suggestion.entity.type})
                 }
              if (suggestion.entity.type == "App\\Models\\Event\\EventItem") {

                this.$emit('open-event-item',suggestion.entity.id)
                    
                if(suggestion.entity.is_poster){
             /*       this.$router.push({
                  name: "posterHall",
                  params: { selectedPosterItem: suggestion.entity.id,selectedSessionItem:'all', selectedTopicTag: null },
                });
                }else{
                  this.$router.push({
                  name: "player",
                  params: { selectedEventItem: suggestion.entity.id },
                });*/
                }
                
              }
         
            }
          },
        });
        this.docsSearchBar = new DocsSearchBar(input);
        this.loading = false;


      
      });
    },

    hideMenu(){
      this.docsSearchBar.autocomplete.autocomplete.close();
    },

    showMenu(){
      if(this.searchInput && this.searchInput.length>0){
        this.docsSearchBar.autocomplete.autocomplete.open()
      }

    },
  

    update(options) {
      //this.$el.innerHTML =
        //  '<input id="iungo-search-input" class="search-query">';
        this.initialize(options);
        setTimeout(() => {
          this.docsSearchBar.autocomplete.autocomplete.open();
        }, 0);

    },
  },
};
</script>
<style >

.docs-searchbar-suggestion--highlight{
  background-color: #dcfce7;
}

.autocomplete-mh{
  max-height: calc(100vh - 4rem);
  min-width: 32rem;
}

@media only screen and (max-width: 47rem) {
  .autocomplete-mh{
  max-height: calc(100vh - 6rem);
  min-width: 23rem;
}
}
@media only screen and (max-width: 64rem) {
  .autocomplete-mh{

  min-width: 23rem;
}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>